import React, { useEffect, useState } from 'react';
import './CSS/Profile.css';
import { Circles } from 'react-loader-spinner';

const Profile = () => {
  const [user, setUser] = useState(null);
  const [orders, setOrders] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProfile = async () => {
      const res = await fetch("/api/profile", {
        headers: {
          'auth-token': localStorage.getItem('auth-token')
        }
      });
      const data = await res.json();
      if (data.success) setUser(data.user);
    };

    const fetchOrders = async () => {
      const res = await fetch("/api/myorders", {
        headers: {
          'auth-token': localStorage.getItem('auth-token')
        }
      });
      const data = await res.json();
      setOrders(data.sort((a, b) => new Date(b.date) - new Date(a.date)));
    };

    const fetchProducts = async () => {
      const res = await fetch("/api/allproducts");
      const data = await res.json();
      setProducts(data);
    };

    const loadAll = async () => {
      setLoading(true);
    
      const headers = {
        'auth-token': localStorage.getItem('auth-token')
      };
    
      const [profileRes, ordersRes] = await Promise.all([
        fetch("/api/profile", { headers }),
        fetch("/api/myorders", { headers }),
      ]);
    
      const profileData = await profileRes.json();
      const ordersData = await ordersRes.json();
    
      if (profileData.success) setUser(profileData.user);
      setOrders(ordersData);
    
      // 🔍 Csak azokat a product ID-kat kérjük le, amik tényleg kellenek
      const allProductIds = Array.from(
        new Set(
          ordersData.flatMap(order => Object.keys(order.cart))
            .map(id => Number(id))
        )
      );
    
      const productRes = await fetch("/api/products-by-ids", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ ids: allProductIds })
      });
    
      const productData = await productRes.json();
      setProducts(productData);
    
      setLoading(false);
    };
    

    loadAll();
  }, []);

  const renderCartItems = (cart) => {
    const productMap = new Map();
    products.forEach(p => productMap.set(Number(p.id), p));

    return Object.entries(cart)
      .filter(([_, quantity]) => quantity > 0)
      .map(([id, quantity]) => {
        const product = productMap.get(Number(id));
        if (!product) return <li key={id}>❗ Ismeretlen termék (ID: {id}) – {quantity} db</li>;

        let displayName = product.name;
        if (product.parentId) {
          const parent = productMap.get(Number(product.parentId));
          if (parent) displayName = parent.name;
        }

        const extras = product.variantAttributes
          ? ` (${product.variantAttributes.color || ""}${product.variantAttributes.size ? " / " + product.variantAttributes.size : ""})`
          : "";

        return <li key={id}>{displayName}{extras} – {quantity} db</li>;
      });
  };

  return (
    <div className="profile-container">
      {loading ? (
        <div className="loader-container">
          <Circles height="80" width="80" color="#4fa94d" ariaLabel="circles-loading" visible={true} />
          <p>Rendelések betöltése...</p>
        </div>
      ) : (
        <>
          <h1>Profilom</h1>
          {user && (
            <div className="profile-info">
              <p><strong>Név:</strong> {user.name}</p>
              <p><strong>Email:</strong> {user.email}</p>
              <p><strong>Regisztráció ideje:</strong> {new Date(user.date).toLocaleDateString()}</p>
            </div>
          )}
          <h2>Rendeléseim</h2>
          {orders.length === 0 && <p>Még nincs leadott rendelésed.</p>}
          {orders.map((order, index) => (
            <div key={index} className="profile-order">
              <p><strong>Dátum:</strong> {new Date(order.date).toLocaleString()}</p>
              <p><strong>Cím:</strong> {order.address}</p>
              <p><strong>Telefonszám:</strong> {order.phone}</p>
              <p><strong>Termékek:</strong></p>
              <ul>{renderCartItems(order.cart)}</ul>
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default Profile;
